// extracted by mini-css-extract-plugin
export default {"map":"Map_map__K5e4c"};